// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Questions
===============
*/

main.single-accordion {
    min-height: 100vh;
    /* using flex because of better browser support */
    display: flex;
    justify-content: center;
    align-items: center;
}


/* .container.single-accordion {
    width: 90vw;
    margin: 5rem auto;
    background: var(--clr-white);
    border-radius: var(--radius);
    padding: 2.5rem 2rem;
    max-width: var(--fixed-width);
    display: grid;
    gap: 1rem 2rem;
}

.container.single-accordion h3 {
    line-height: 1.2;
    font-weight: 500;
} */


/* @media screen and (min-width: 992px) {
    .container.single-accordion {
        display: grid;
        grid-template-columns: 250px 1fr;
    }
} */

.question {
    padding: 0.7rem 1.5rem;
    /* border: 2px solid var(--clr-grey-5); */
    margin-bottom: 1rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

.question h4 {
    text-transform: none;
    line-height: 1.5;
}

.question p {
    color: var(--clr-grey-3);
    margin-bottom: 0;
    margin-top: 0.5rem;
}

.question header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.question header h4 {
    margin-bottom: 0;
}

.btn-nobs {
    /* background: transparent; */
    border-color: transparent;
    width: 2rem;
    height: 2rem;
    background: var(--clr-grey-5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: var(--clr-white);
    cursor: pointer;
    margin-left: 1rem;
    align-self: center;
    min-width: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/ui-components/singleaccordion.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,iBAAiB;IACjB,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;;;;;;;;;;;;;;GAcG;;;AAGH;;;;;GAKG;;AAEH;IACI,sBAAsB;IACtB,yCAAyC;IACzC,mBAAmB;IACnB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["/*\r\n=============== \r\nQuestions\r\n===============\r\n*/\r\n\r\nmain.single-accordion {\r\n    min-height: 100vh;\r\n    /* using flex because of better browser support */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n/* .container.single-accordion {\r\n    width: 90vw;\r\n    margin: 5rem auto;\r\n    background: var(--clr-white);\r\n    border-radius: var(--radius);\r\n    padding: 2.5rem 2rem;\r\n    max-width: var(--fixed-width);\r\n    display: grid;\r\n    gap: 1rem 2rem;\r\n}\r\n\r\n.container.single-accordion h3 {\r\n    line-height: 1.2;\r\n    font-weight: 500;\r\n} */\r\n\r\n\r\n/* @media screen and (min-width: 992px) {\r\n    .container.single-accordion {\r\n        display: grid;\r\n        grid-template-columns: 250px 1fr;\r\n    }\r\n} */\r\n\r\n.question {\r\n    padding: 0.7rem 1.5rem;\r\n    /* border: 2px solid var(--clr-grey-5); */\r\n    margin-bottom: 1rem;\r\n    border-radius: var(--radius);\r\n    box-shadow: var(--light-shadow);\r\n}\r\n\r\n.question h4 {\r\n    text-transform: none;\r\n    line-height: 1.5;\r\n}\r\n\r\n.question p {\r\n    color: var(--clr-grey-3);\r\n    margin-bottom: 0;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.question header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.question header h4 {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.btn-nobs {\r\n    /* background: transparent; */\r\n    border-color: transparent;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    background: var(--clr-grey-5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    color: var(--clr-white);\r\n    cursor: pointer;\r\n    margin-left: 1rem;\r\n    align-self: center;\r\n    min-width: 2rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
